import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SmartScrollService {

    scrollTo (containerElement: Element, sectionID: string, offsetTop?: number): void {
        setTimeout(() => {
            const target = document.getElementById(sectionID);
            offsetTop = offsetTop || 0;
            if (target) {
                const targetPosition = this.cumulativeOffset(target).top - offsetTop;
                containerElement.scroll({
                    top: targetPosition,
                    behavior: 'smooth',
                });
            }
        });
    }

    private cumulativeOffset (element: Element): { top: number; left: number } {
        let top = 0;
        let left = 0;
        let currentElement = element as HTMLElement;

        while (currentElement) {
            top += currentElement.offsetTop || 0;
            left += currentElement.offsetLeft || 0;
            currentElement = currentElement.offsetParent as HTMLElement;
        }

        return {
            top: top,
            left: left,
        };
    }
}
